import { API_BASE_REPORT_API_URL } from '../../urls';

export const API_FILES_URL = `${API_BASE_REPORT_API_URL}/files`;

export const API_FILES_GET_URL = `${API_FILES_URL}/get`;
export const API_FILES_SET_URL = `${API_FILES_URL}/set`;
export const API_FILES_ADD_URL = `${API_FILES_URL}/add`;
export const API_FILES_DELETE_URL = `${API_FILES_URL}/del`;
export const API_FILES_GET_UPLOAD_URL = `${API_FILES_URL}/upload-url`;
